/**
 * Apollo-контекст платформенных операций.
 *
 * Флаг `platform` в `apollo-provider` отключает tenant-заголовок `X-Organization-Id`,
 * поэтому его обязана указывать каждая операция платформенной консоли.
 */
export const platformContext = {
  context: {
    platform: true,
  },
} as const;

/**
 * Контекст платформенных мутаций: ошибки обрабатывает вызывающий код,
 * глобальный обработчик и тост подавляются.
 */
export const platformMutationContext = {
  context: {
    platform: true,
    suppressGlobalErrorHandling: true,
    suppressGlobalErrorToast: true,
  },
} as const;
